import React from "react";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-gray-800 text-white py-8 mt-8 md:mt-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4">
              Interstate Parking
            </h3>
            <p className="text-gray-300">
              Providing convenient and secure parking solutions for all your
              needs.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/about" className="text-blue-300 hover:text-blue-100">
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/locations"
                  className="text-blue-300 hover:text-blue-100"
                >
                  Locations
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-blue-300 hover:text-blue-100"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-blue-300 hover:text-blue-100"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <address className="not-italic text-gray-300">
              <p>123 Parking Avenue</p>
              <p>City, State 12345</p>
              <p className="mt-2">Email: info@interstateparking.com</p>
              <p>Phone: (123) 456-7890</p>
            </address>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400">
          <p>&copy; {currentYear} Interstate Parking. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
